import { Award } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RankBadgeProps {
    rank?: { id: number; name: string } | null;
    size?: 'sm' | 'lg';
    showLabel?: boolean;
}

const RankBadge: React.FC<RankBadgeProps> = ({ rank, size = 'sm', showLabel = true }) => {
    const { t } = useTranslation();
    const rankName = rank?.name || t('home.noRank');

    if (size === 'lg') {
        return (
            <div className="inline-flex flex-col items-center gap-2">
                <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-amber-400 to-orange-500 shadow-lg">
                    <Award size={40} className="text-white" />
                </div>
                <span className="text-3xl font-bold text-orange-600 dark:text-amber-400">
                    {rankName}
                </span>
                {showLabel && (
                    <span className="text-sm font-medium text-gray-500 dark:text-neutral-400">
                        {t('home.conquerRanks')}
                    </span>
                )}
            </div>
        );
    }

    return (
        <div className="flex items-center space-x-1">
            <Award size={14} className="text-amber-500" />
            {showLabel && (
                <span className="text-xs font-medium text-amber-700">
                    {t('home.conquerRanks')}
                </span>
            )}
            <span className="text-xs font-bold text-orange-600">{rankName}</span>
        </div>
    );
};

export default RankBadge;
